export default __webpack_public_path__ + "static/media/hero-img.66b9eb77.png";